import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { AutopilotBoard } from "@/components/admin/products/Autopilot";

export const Route = createFileRoute("/_authenticated/admin/ai-jobs")({
  head: () => ({
    meta: [
      { title: "Админ — AI задачи | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <AutopilotBoard />
    </AdminLayout>
  ),
});
